export enum RoundingMethods {
    ROUNDING_METHOD_DOWN = 'Always Round Down',
    ROUNDING_METHOD_UP = 'Always Round Up',
    ROUNDING_METHOD_MIDDLE = 'Round Up Past Halfway Point',
}

export enum InterestMethods {
    SIMPLE_DAILY = 'Simple Daily',
    SIMPLE_MONTHLY = 'Simple Monthly',
    FLAT_MONTHLY = 'Flat Monthly Fee',
}

// Constants for option values
// export default {
//     ROUNDING_METHOD_DOWN: 'Always Round Down',
//     ROUNDING_METHOD_UP: 'Always Round Up',
//     ROUNDING_METHOD_MIDDLE: 'Round Up Past Halfway Point',
// }
